/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface PresetItemCreate {
  /**
     * @minLength 1
     * @maxLength 500
     */
  name: string;
  canonical_id?: string | null;
  domain?: string | null;
}
